"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var colors_1 = require("../../themes/colors");
var ActionMenu_1 = require("../../../components/ActionMenu");
var phosphor_react_1 = require("phosphor-react");
var mixins_1 = require("../../../themes/mixins");
var Typo2_1 = require("../Typo2");
var useStyleUpdateAfterToggleTransition_1 = require("../../../utils/useStyleUpdateAfterToggleTransition");
var StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 0.8rem;\n  border: 1px solid ", ";\n  background: #ffffff;\n  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);\n"], ["\n  border-radius: 0.8rem;\n  border: 1px solid ", ";\n  background: #ffffff;\n  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);\n"])), colors_1.colors.grey10);
var StyledHeader = styled_components_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  padding: 1rem 1.6rem;\n  text-align: left;\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n"], ["\n  width: 100%;\n  padding: 1rem 1.6rem;\n  text-align: left;\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n"])));
var StyledRightHeaderSection = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var ArrowWrapper = styled_components_1.default.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border: none;\n  background: none;\n  cursor: pointer;\n  width: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform: rotate(", "deg);\n  ", ";\n"], ["\n  border: none;\n  background: none;\n  cursor: pointer;\n  width: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform: rotate(", "deg);\n  ", ";\n"])), function (props) { return (props.isExpanded ? 0 : 180); }, (0, mixins_1.transition)("transform"));
var StyledContentWrapper = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-end;\n  \n  ", "\n  height: ", ";\n"], ["\n  display: flex;\n  align-items: flex-end;\n  \n  ", "\n  height: ", ";\n"])), function (_a) {
    var expandAnimationDuration = _a.expandAnimationDuration;
    return (0, mixins_1.transition)("height ".concat(expandAnimationDuration / 1000, "s ease-out"));
}, function (_a) {
    var height = _a.height;
    return height;
});
var StyledContentInnerWrapper = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  /* padding: 1.6rem;\n  padding-bottom: 1rem; */\n  padding-top: 0;\n  width: 100%;\n"], ["\n  /* padding: 1.6rem;\n  padding-bottom: 1rem; */\n  padding-top: 0;\n  width: 100%;\n"])));
var CustomActionMenuSelectButton = function (_a) {
    var active = _a.active, onClick = _a.onClick;
    return (react_1.default.createElement("div", { onClick: onClick, style: {
            cursor: "pointer",
            border: "none",
            background: "none",
            display: "flex",
            alignItems: "center",
            width: "2rem",
            justifyContent: "center",
        } },
        react_1.default.createElement(phosphor_react_1.DotsThree, { size: 16, style: { pointerEvents: 'none' } })));
};
var useCalculateWrapperHeight = function (_a) {
    var isExpanded = _a.isExpanded;
    var wrapperRef = (0, react_1.useRef)(null);
    // Then in your Accordion component, add this state:
    var _b = (0, react_1.useState)(isExpanded ? "auto" : "0px"), contentHeight = _b[0], setContentHeight = _b[1];
    // Add this useEffect to measure and update height when content changes
    (0, react_1.useEffect)(function () {
        if (wrapperRef.current) {
            var height = wrapperRef.current.scrollHeight;
            setContentHeight(isExpanded ? "".concat(height, "px") : "0px");
        }
    }, [isExpanded]); // depends on isExpanded state
    return ({
        wrapperHeight: contentHeight,
        wrapperRef: wrapperRef
    });
};
var Accordion = function (_a) {
    var title = _a.title, children = _a.children, _b = _a.defaultExpanded, defaultExpanded = _b === void 0 ? true : _b, _c = _a.actionsConfig, actionsConfig = _c === void 0 ? [
        {
            display: "Grouped",
            onClick: function () { return console.log("grouped"); },
        },
        {
            display: "Stacked",
            onClick: function () { return console.log("stacked"); },
        },
    ] : _c;
    var _d = (0, react_1.useState)(defaultExpanded), isExpanded = _d[0], setIsExpanded = _d[1];
    var _e = useCalculateWrapperHeight({ isExpanded: isExpanded }), wrapperRef = _e.wrapperRef, wrapperHeight = _e.wrapperHeight;
    var expandAnimationDuration = 300;
    var accordionOverflow = (0, useStyleUpdateAfterToggleTransition_1.useStyleUpdateAfterToggleTransition)({
        styleOptions: ['hidden', 'visible'],
        initStyle: 'hidden',
        toggleState: isExpanded,
        transitionDuration: expandAnimationDuration
    }).style;
    return (react_1.default.createElement(StyledContainer, null,
        react_1.default.createElement(StyledHeader, { onClick: function () { return setIsExpanded(!isExpanded); } },
            react_1.default.createElement("div", { style: { flex: "1 0 0" } },
                react_1.default.createElement(Typo2_1.UI_BODY_BOLD_SM, null, title)),
            react_1.default.createElement(StyledRightHeaderSection, null,
                react_1.default.createElement(ArrowWrapper, { isExpanded: isExpanded },
                    react_1.default.createElement(phosphor_react_1.CaretDown, { size: 16 })),
                actionsConfig && (react_1.default.createElement(ActionMenu_1.ActionMenu, { CustomSelectComp: CustomActionMenuSelectButton, actions: actionsConfig })))),
        react_1.default.createElement(StyledContentWrapper, { height: wrapperHeight, style: { overflow: accordionOverflow }, expandAnimationDuration: expandAnimationDuration },
            react_1.default.createElement(StyledContentInnerWrapper, { ref: wrapperRef }, children))));
};
exports.Accordion = Accordion;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
